<template>
    <section
        v-if="content"
        class="c-pwa-power-of-pwa"
    >
        <div class="c-pwa-power-of-pwa__title">
            <h2>
                {{ content.title }}
            </h2>
        </div>
        <div class="c-pwa-power-of-pwa__content">
            <div
                v-for="item in content.stats"
                :key="item.title"
                class="stat"
            >
                <p class="stat__number">
                    {{ item.stat }}
                </p>
                <h3 class="stat__title">
                    {{ item.title }}
                </h3>
                <p class="stat__description">
                    {{ item.description }}
                </p>
            </div>
        </div>
    </section>
</template>

<script>

    export default {
        name: 'PowerOfPWA',

        /**
         * @inheritdoc
         */
        props: {
            content: Object,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
